import React, { useEffect, useState } from "react";
import "./VehicleAlertModal.css";
import socketService from "socket/newsocketService";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import warningIcon from "../assets/warning.png";

const VehicleAlertModal = ({ data, onClose }) => {
  const [timer, setTimer] = useState(118);

  // console.log("data in modal", data);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimer((prev) => {
        if (prev > 0) {
          return prev - 1;
        } else {
          onClose();
          return 0;
        }
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [onClose]);

  const formatTime = () => {
    const min = String(Math.floor(timer / 60)).padStart(2, "0");
    const sec = String(timer % 60).padStart(2, "0");
    return `${min}:${sec}`;
  };

  const handleViewMap = () => {
    const location = data.location || "";
    const encodedLocation = encodeURIComponent(location);

    const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodedLocation}`;

    window.open(googleMapsUrl, "_blank");
  };

 const handleDispatch = () => {
  const payload = {
    alert_type: "PowerCut",
    alert_message: `Power disconnected for ${data?.vehicleNickname}`,

    Latitude: Number(data?.currentLat || data?.lat || 0),
    Longitude: Number(data?.currentLong || data?.lng || 0),

    isRead: true,

    user_Img: data?.profile || "",
    user_Name: data?.ownerName || "",
    user_Phone: data?.phone || "",

    vehicleName: data?.vehicleNickname || "",
    vehicleNumber: data?.licensePlate  || "",

    location: data?.location || "",

    timestamp: data?.createdAt || new Date().toISOString(),
    userId: data?.userId || "",
  };

  console.log("Dispatch Payload:", payload);

  socketService.emit("sendalert", {
    payload,
    isBroadcast: false,
  });
console.log("Alert emitted to Vigilanteye with payload:", payload);
  toast.info("Security dispatched");
  onClose();
};
  if (!data) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          <span className="alert-text">🚨 POWER CUT ALERT</span>
        </div>

        <div className="modal-body">
          <div className="info-row">
            <span className="label">🚗 Vehicle:</span>
            <span>{data.vehicleNickname}</span>
          </div>

          <div className="info-row">
            <span className="label">👤 Owner:</span>
            <span>{data.ownerName}</span>
          </div>

          <div className="info-row">
            <span className="label">📞 Phone:</span>
            <span>{data.phone}</span>
          </div>

          <div className="divider" />

          <div className="location-row">
            <span>📍 {data.location || "Unknown Location"}</span>
            <span className="map-link" onClick={handleViewMap}>
              View on Map
            </span>
          </div>

          <div className="time-row">⏱ {new Date().toLocaleString()}</div>

          <div className="divider" />

          <div className="info-row">
            <span className="label">🔌 Status:</span>
            <span>Power Disconnected</span>
          </div>

          <div className="risk">
            ⚠ Risk Level: <b>HIGH (Possible Theft Attempt)</b>
          </div>

          <div className="action-row">
            <div className="timer-circle">{formatTime()}</div>

            <button
              className="call-btn"
              onClick={() => {
                navigator.clipboard.writeText(data.phone);
                alert(`Owner's Phone Number copied: ${data.phone}`);
              }}
            >
              📞 Call Owner
            </button>

            <button className="disable-btn" onClick={onClose}>
              🚗 Disable Engine
            </button>
          </div>

          <button className="dispatch-btn" onClick={handleDispatch}>
            <img src={warningIcon} alt="warning" className="btn-icon" />
            DISPATCH TO VIGILANTEYE
          </button>
        </div>
      </div>
    </div>
  );
};

export default VehicleAlertModal;
